export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 1_15.18f27944.jpg";